import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          综艺在线观看平台最新更新与动态
        </p>
        <div className="relative pl-8 border-l-2 border-background-200">
          {updatesData.map((item, index) => (
            <div key={item.id} className={`relative mb-8 ${index === updatesData.length - 1 ? 'mb-0' : ''}`}>
              <div className="absolute -left-[33px] top-0 w-[14px] h-[14px] rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex items-start gap-4">
                <span className="text-xs font-bold text-primary-500 bg-primary-50 px-3 py-1 rounded-full whitespace-nowrap mt-0.5">
                  {item.date}
                </span>
                <div className="flex-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap mr-2 ${
                    item.tag === '最新上线' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '热门更新' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '平台动态' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-background-200 text-foreground-600'
                  }`}>
                    {item.tag}
                  </span>
                  <p className="text-sm text-foreground-700 mt-1 leading-relaxed">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}